import { ApiEndpointBuilder } from "@/services/api/types";
import { ProrateResponse } from "../types";
import { UpdateSubscriptionRequest } from "@/store/tenants/endpoints/tenants";

const prorateSubscription = (builder: ApiEndpointBuilder) => {
  return builder.query<ProrateResponse, UpdateSubscriptionRequest>({
    query: request => ({
      url: `/checkout/subscription/prorate`,
      method: "POST",
      body: request,
    }),
  });
};
export default prorateSubscription;
